<template>
  <div>
    <div class="row">
      <div class="col">
        <h5>Vortragsform</h5>
        <div>
          Wählen Sie eine Vortragsform.
          <br>
          Bitte beachten Sie die Hinweise zu den  <a href="https://ergo2023.abstractserver.com/documents/Information_zur_Abstracteinreichung.pdf" target="_blank"
                                                                    class="">unterschiedlichen Präsentationsmöglichkeiten (pdf)</a>.
          <br>
          Bitte beachten Sie die Hinweise zur Formulierung eines <a href="https://ergo2023.abstractserver.com/documents/Info_aussagekraeftiges_Abstract.pdf" target="_blank"
                                                                    class="">aussagekräftigen Abstracts (pdf)</a>.
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="alert alert-info mb-1">
          <div class="row">
            <div class="col-1 d-flex">
              <icon :icon="['fad', 'exclamation']" class="my-auto fa-2x"/>
            </div>
            <div class="col">
              Bitte beachten Sie, dass Sie eine einmal gewählte Vortragsform nicht änden können.<br>
              Möchten Sie eine andere Vortragsform wählen, müssen Sie einen neuen Beitrag anlegen.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Vortrag<br><br>20 Minuten inkl. Diskussion</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(1)">Auswählen</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Impulsvortrag<br><br>10 Minuten mit anschließendem Austausch zum Thema (20 Min.)</h5>
            Als Referent:in moderieren Sie diese Runde selbst.
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(4)">Auswählen</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Studie<br><br>10 Minuten inkl. Diskussion</h5>


            Sie stellen eine Bachelor-/Masterarbeit vor - bitte beachten Sie diese <a href="https://ergo2023.abstractserver.com/documents/2023_Hinweise_Studien.pdf" target="_blank">Hinweise</a> (PDF).

          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(2)">Auswählen</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Workshop<br><br>90 Minuten</h5>

            Bitte beachten Sie die <a href="https://ergo2023.abstractserver.com/documents/2023_Hinweise_Workshop.pdf" target="_blank">Hinweise</a> für Workshop-Referentinnen/Referenten
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(3)">Auswählen</button>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'

export default {
  name: "AbstractType",
  data() {
    return {
      submitted: false,
    };
  },
  methods: {
    ...mapActions([
      'CREATE_ABSTRACT', 'UPDATE_REFERENCE'
    ]),
    newAbstract(type) {
      if (this.submitted === true) {
        return false;
      }
      this.submitted = true;
      let template = {
        "user_id": this.user.id,
        "type_id": type,
        "setting_submission_id": 1,
        "reference_number": this.getSettings(1).reference_number,
        "content": {},
        "status_id": 1
      };
      this.CREATE_ABSTRACT(template).then((response) => {
        this.$noty.success(this.wording[0].notify.save_success);
        this.$router.push('abstract/' + response.data.id + '/dynamic/' + this.getFirstCurrentPage(1).id)
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.save_not_success);
      });
    }
  },
  computed: {
    ...mapState([
      'wording', 'user'
    ]),
    ...mapGetters([
      'getSettings', 'getFirstCurrentPage'
    ]),
  },
}
</script>

<style scoped>

</style>
